// extracted by mini-css-extract-plugin
export default {"message":"O7K1n5","credit-message":"F64OKy","creditMessage":"F64OKy"};